import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-57bcf01c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  style: {"height":"100%"},
  class: "custom-popup-content"
}
const _hoisted_2 = {
  key: 0,
  class: "custom-tab"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, null, -1))
const _hoisted_6 = { style: {"flex":"1","overflow-y":"auto"} }
const _hoisted_7 = { class: "custom-popup-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_Customer = _resolveComponent("Customer")!
  const _component_House = _resolveComponent("House")!
  const _component_Other = _resolveComponent("Other")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createBlock(_component_van_popup, {
    show: _ctx.popupShow,
    "onUpdate:show": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.popupShow) = $event)),
    position: "right",
    style: { height: '100vh', width: '100%', background: '#f6f7fa' }
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_van_nav_bar, {
          title: "选择被访对象",
          "left-text": "返回",
          "left-arrow": "",
          onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.popupShow = false))
        }),
        (!_ctx.showTab)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_2, [
              (_ctx.customerList.length)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 0,
                    class: _normalizeClass(["custom-tab-item", _ctx.active === 'customer' && 'active']),
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.active = 'customer'))
                  }, [
                    _createTextVNode(" 访问客户机构 "),
                    _hoisted_3
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.houseList.length)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 1,
                    class: _normalizeClass(["custom-tab-item", _ctx.active === 'house' && 'active']),
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.active = 'house'))
                  }, [
                    _createTextVNode(" 访问住宅 "),
                    _hoisted_4
                  ], 2))
                : _createCommentVNode("", true),
              (_ctx.otherList.length)
                ? (_openBlock(), _createElementBlock("li", {
                    key: 2,
                    class: _normalizeClass(["custom-tab-item", _ctx.active === 'other' && 'active']),
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.active = 'other'))
                  }, [
                    _createTextVNode(" 其他 "),
                    _hoisted_5
                  ], 2))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createVNode(_component_Customer, {
            ref: "customerRef",
            data: _ctx.state.customer,
            onChange: _cache[4] || (_cache[4] = (data) => _ctx.updateState(data, 'customer'))
          }, null, 8, ["data"]), [
            [_vShow, _ctx.active === 'customer']
          ]),
          _withDirectives(_createVNode(_component_House, {
            ref: "houseRef",
            data: _ctx.state.house,
            onChange: _cache[5] || (_cache[5] = (data) => _ctx.updateState(data, 'house'))
          }, null, 8, ["data"]), [
            [_vShow, _ctx.active === 'house']
          ]),
          _withDirectives(_createVNode(_component_Other, {
            ref: "otherRef",
            data: _ctx.state.other,
            onChange: _cache[6] || (_cache[6] = (data) => _ctx.updateState(data, 'other'))
          }, null, 8, ["data"]), [
            [_vShow, _ctx.active === 'other']
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_van_button, {
            class: "btn",
            color: "#3d6eeb",
            square: "",
            type: "success",
            onClick: _ctx.confirm
          }, {
            default: _withCtx(() => [
              _createTextVNode("确认 ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ]),
    _: 1
  }, 8, ["show"]))
}